import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { useSelector } from "react-redux";
import "./OrderHistory.css";
import {
  NextArrow,
  PrevArrow,
} from "../../components/SlickButtons/SlickButtons";
import { useGetOrders } from "../../hooks/useGetOrders";

const PER_PAGE = 10;

function OrderHistory() {
  const token = useSelector((state) => state.auth.token);
  const [page, setPage] = useState(1);
  const { data: orderData, isLoading, error } = useGetOrders(page, token, PER_PAGE);

  const orderHistory = orderData?.data || [];
  const totalPages = orderData?.total_pages || 0;

  // Handle loading state
  if (isLoading) {
    return (
      <div className="loading">
        <div className="section-title">
          <h3>Order History</h3>
        </div>
        <p>Loading your orders...</p>
        {/* Optionally add a spinner here */}
      </div>
    );
  }

  // Handle error state
  if (error) {
    return (
      <div className="error">
        <h3>Error loading past orders</h3>
        <button onClick={() => setPage(1)}>Retry</button>
      </div>
    );
  }

  // Handle empty order history
  if (orderHistory && orderHistory.length === 0) {
    return (
      <section className="OrderHistory">
        <div className="section-title">
          <h3>Order History</h3>
        </div>
        <div className="order-details">
          <p>No past orders found</p>
        </div>
      </section>
    );
  }

  return (
    <section className="OrderHistory">
      <div className="section-title">
        <h3>Order History</h3>
      </div>
      {orderHistory?.map((order) => {
        return (
          <div key={order.date_created} className="order-details">
            <p className="order-date">
              {format(parseISO(order?.date_created), "MMMM d, yyyy, h:mm a")}
            </p>
            {order?.line_items?.map((item) => {
              return (
                <div key={item?.id} className="item">
                  <p>{item?.name}</p>
                  <p>${item?.total}</p>
                </div>
              );
            })}
            <p className="order-total">Total: ${order?.total}</p>
          </div>
        );
      })}
      <div className="pagination-btn">
        {/* Prev Button */}
        <button
          onClick={() => {
            if (page > 1) {
              setPage((prevPage) => prevPage - 1);
            }
          }}
          disabled={page === 1 || orderHistory?.length === 0}
        >
          <PrevArrow />
        </button>
        {/* Next Button */}
        <span>{page} of {totalPages}</span>
        <button
          onClick={() => {
            setPage((prevPage) => prevPage + 1);
          }}
          disabled={page === totalPages || orderHistory?.length === 0}
        >
          <NextArrow />
        </button>
      </div>
    </section>
  );
}

export default OrderHistory;
